export default "__VITE_ASSET__eN6Uc46w__"